import { useParams, useNavigate } from 'react-router-dom';
import InvestigationDetails from '@/components/investigations/InvestigationDetails';

const InvestigationDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/security/investigations');
  };

  if (!id) {
    return (
      <div className="text-center py-8">
        <p className="text-danger-600 dark:text-danger-400">Invalid investigation ID</p>
      </div>
    );
  }

  return (
    <InvestigationDetails
      investigationId={id}
      onBack={handleBack}
    />
  );
};

export default InvestigationDetailsPage;